import { Box } from "@mui/material";
import './AuthLayout.css'
import image from '../../../assets/img/manvar-login.png';

export const AuthLayout = ({ children }) => {

    return (
        <Box className="background-image auth-layout">
            <Box className="auth-layout__content">
                <Box component="section" className="auth-layout__brand">
                    <Box className="auth-layout__brand-inner">
                        <p className="auth-layout__eyebrow">PLATAFORMA CORPORATIVA</p>

                        <Box
                            component="img"
                            className="auth-layout__logo"
                            src={image}
                            alt="Grupo MANVAR S.A."
                        />

                        <p className="auth-layout__caption">
                        ACCESO PARA PERSONAL AUTORIZADO
                        </p>
                    </Box>
                </Box>

                <Box className="auth-layout__divider" aria-hidden="true" />

                <Box component="section" className="auth-layout__form-area">
                    <Box className="auth-layout__card">{children}</Box>
                </Box>
            </Box>
        </Box>
    );
}